<template>
  <div class="row">
    <div class="col-md-12 pb-3">
      <h3 class="rel-title-menu">Estudios</h3>
      <hr class="rel-hr-title" />
      <h4 class="mt-5">Educación</h4>
      <div class="container-fluid">
        <div class="row justify-content-between pl-4 pr-4">
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-user-cog rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Ingeniero Multimedia</h5>
                  <p class="text-secondary mb-3 mt-0">Enero 2013 - Junio 2019</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p
                    class="rel-paragraph-proyect text-white-50 text-justify p-0"
                  >Se está realizando en la Universidad Autónoma de Occidente en la ciudad de Santiago de Cali con prevista obtención del título en el año 2020.</p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-user-graduate rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Técnico En Instalaciones Eléctricas Residenciales</h5>
                  <p class="text-secondary mb-3 mt-0">Enero 2010 - Junio 2013</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p
                    class="rel-paragraph-proyect text-white-50 text-justify p-0"
                  >Realizado en el Colegio Comfandi el Prado de la ciudad de Santiago de Cali con obtención del título en el año 2013.</p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-user-graduate rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Bachiller</h5>
                  <p class="text-secondary mb-3 mt-0">Enero 2007 - Junio 2013</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p
                    class="rel-paragraph-proyect text-white-50 text-justify p-0"
                  >Realizado en el Colegio Comfandi el Prado de la ciudad de Santiago de Cali con obtención del titulo en el año 2013.</p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
      <h4 class="mt-4">Certificados</h4>
      <div class="container-fluid">
        <div class="row justify-content-between pl-4 pr-4">
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Taller Para Monitores En Recreación</h5>
                  <p class="text-secondary mb-3 mt-0">Noviembre 2017</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p class="rel-paragraph-proyect text-white-50 text-justify p-0">
                    Certificado por Moncho Recreo Recreación,
                    <b>Nit: 900.144.426-7,</b> Santiago de Cali.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Escuela De Liderazgo Promocion XXXII</h5>
                  <p class="text-secondary mb-3 mt-0">Junio 2015</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p
                    class="rel-paragraph-proyect text-white-50 text-justify p-0"
                  >Certificado por Bienestar Universitario, Universidad Autonoma de Occidente, Santiago de Cali.</p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">SQL Fundamentals Course</h5>
                  <p class="text-secondary mb-3 mt-0">Septiembre 2017</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p class="rel-paragraph-proyect text-white-50 text-justify p-0">
                    Certificado por SOLOLEARN,
                    <b>certificado #1060-6081380</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Java Tutorial Course</h5>
                  <p class="text-secondary mb-3 mt-0">Junio 2018</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p class="rel-paragraph-proyect text-white-50 text-justify p-0">
                    Certificado por SOLOLEARN,
                    <b>certificado #1068-6081380</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">JavaScript Tutorial Course</h5>
                  <p class="text-secondary mb-3 mt-0">Mayo 2018</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p class="rel-paragraph-proyect text-white-50 text-justify p-0">
                    Certificado por SOLOLEARN,
                    <b>certificado #1024-6081380</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Estudy",
  components: {}
};
</script>

<style>
</style>